module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vregi7-f73311e27c92f916a7d2b2ddd326133b.jpg";